import type createMovementCostGridUInt8Array from '../MovementCostGrid/createMovementCostGridUInt8Array'
import { ImpassValue } from './ImpassValue.enum'

export default function createImpassValueGridFromMovementCostGrid(
  grid: ReturnType<typeof createMovementCostGridUInt8Array>,
) {
  const data = new Uint8Array(grid.length)

  for (let i = 0; i < grid.length; i++) {
    data[i] = grid[i] === 255 ? ImpassValue.Impassible : ImpassValue.Passible
  }

  return data
}
